import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import request from 'superagent'; // eslint-disable-line no-restricted-imports
import { Button } from '@99designs/common/components/Button';
import ContestSelect from '../../invite-designer/components/ContestSelect';
import InviteAlert from '../../invite-designer/components/InviteAlert';
import RemainingInvitesMessage from '../../invite-designer/components/RemainingInvitesMessage';
import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';

export default class InviteDesignerForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            messageFieldValue: '',
            errorMessage: '',
            selectedContest: this.props.contests[0],
            contests: this.props.contests,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    UNSAFE_componentWillReceiveProps() {
        this.setState(() => ({
            errorMessage: '',
        }));
    }

    csrfToken() {
        return document.querySelector('meta[name="csrf-token"]').content;
    }

    handleChange(event) {
        if (event.target) {
            this.setState({ messageFieldValue: event.target.value });
        } else {
            this.setState(() => ({
                selectedContest: this.state.contests.find(
                    contest => contest.id === Number(event.value)
                ),
                showModal: false,
                isSuccessful: false,
                messageFieldValue: '',
            }));
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        request
            .post(this.props.inviteDesignerUrl)
            .send({
                invite_message: this.state.messageFieldValue,
                listing_id: this.state.selectedContest.id,
                designer_id: this.props.designerId,
            })
            .set({
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            })
            .set('X-CSRF-Token', this.csrfToken())
            .then(res => {
                const selectedContest = res.body.find(
                    contest => contest.id === this.state.selectedContest.id
                );
                this.setState({
                    contests: res.body,
                    selectedContest,
                });
                this.props.handleSuccess(selectedContest);
            })
            .catch(err =>
                this.setState(() => ({
                    errorMessage:
                        err.response && err.response.body ? (
                            err.response.body.errorMessage
                        ) : (
                            <FormattedMessage id="error" />
                        ),
                }))
            );
    }

    form() {
        if (this.state.selectedContest.remainingInvites === 0) return null;
        if (!this.state.selectedContest.isEligible) return null;

        return (
            <form onSubmit={this.handleSubmit}>
                <div className="field">
                    <h2 className="field__title">
                        <FormattedMessage
                            id="send_message"
                            values={{ designer_name: this.props.designerName }}
                        />
                    </h2>
                    <div className="field__input">
                        <textarea
                            className="input-textarea"
                            required
                            value={this.state.messageFieldValue}
                            onChange={this.handleChange}
                        />
                    </div>
                    <RemainingInvitesMessage
                        remainingInvites={this.state.selectedContest.remainingInvites}
                        timeRemaining={this.state.selectedContest.timeRemaining}
                    />
                </div>
                <ButtonGroup variations={['responsive']}>
                    <ButtonGroupItem>
                        <Button href={``} onClick={() => {}} variations={['primary']}>
                            Send Invite
                        </Button>
                    </ButtonGroupItem>
                    <ButtonGroupItem>
                        <Button onClick={this.props.handleCancel} variations={['secondary']}>
                            Cancel
                        </Button>
                    </ButtonGroupItem>
                </ButtonGroup>
            </form>
        );
    }

    render() {
        return (
            <div>
                <ContestSelect
                    contests={this.state.contests}
                    selectedContestId={this.state.selectedContest.id.toString()}
                    handleChange={this.handleChange}
                />
                <InviteAlert
                    remainingInvites={this.state.selectedContest.remainingInvites}
                    timeRemaining={this.state.selectedContest.timeRemaining}
                    isEligible={this.state.selectedContest.isEligible}
                    ineligibilityReason={this.state.selectedContest.ineligibilityReason}
                    errorMessage={this.state.errorMessage}
                />
                {this.form()}
            </div>
        );
    }
}

InviteDesignerForm.propTypes = {
    handleSuccess: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    contests: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            title: PropTypes.string.isRequired,
            remainingInvites: PropTypes.number.isRequired,
            timeRemaining: PropTypes.string.isRequired,
        })
    ).isRequired,
    designerId: PropTypes.number.isRequired,
    designerName: PropTypes.string.isRequired,
    inviteDesignerUrl: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/InviteDesignerForm.jsx